import { render, staticRenderFns } from "./create-order-material.vue?vue&type=template&id=3d3ec660&scoped=true"
import script from "./create-order-material.vue?vue&type=script&lang=js"
export * from "./create-order-material.vue?vue&type=script&lang=js"
import style0 from "./create-order-material.vue?vue&type=style&index=0&id=3d3ec660&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3ec660",
  null
  
)

export default component.exports